import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Add } from '@material-ui/icons';
import { Button, Paper } from '@roc/ui';
import { observer } from 'mobx-react';
import { useGeneralTasksStore } from '../../hooks/useGeneralTasksStore';
import { TaskListView } from '../taskListView';
import { EditSupportTaskDialog } from './editSupportTaskDialog';
import { useEffect, useState } from 'react';
import { isNil } from '@roc/feature-utils';
import { SupportTasksToolbar } from '../supportTasksToolbar';
import { AddLoanTaskDialog } from '../addLoanTask/addLoanTaskDialog';

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
    width: '100%',
  },
  mainContainer: {
    width: '100%',
    marginTop: '15px',
  },
  container: {
    width: '100%',
  },
}))

export const SupportTasksComponent = observer(() => {
  const classes = useStyles();
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore, supportTasksStore, supportTasksGridStore } = generalTasksStore;
  const [openCreateTask, setOpenCreateTask] = useState(false);

  useEffect(() => {
    if (isNil(editTaskStore.dialogState)) {
      supportTasksStore.fetchUnreadMessagesCount();
      supportTasksGridStore.resetAndFetchGridData();
    }
  }, [editTaskStore.dialogState, supportTasksStore.openModal]);

  const handleCloseCreateTask = () => {
    setOpenCreateTask(false);
    supportTasksStore.fetchUnreadMessagesCount();
    supportTasksGridStore.resetAndFetchGridData();
  };

  return (

    <>
      <Grid container className={classes.mainContainer} xs={12} md={12}>
        <Box className={classes.container} display="flex" flexDirection="column" height={'80vh'} >
          <Box pb={2} >
            <Paper className={classes.paper}>
              <Box display="flex">
                <Box flex={1} display="flex" alignItems="center">
                  <Typography variant="body1">
                    Please select new task and give the information needed to solve your issue!
                  </Typography>
                </Box>
                <Box flex={1} textAlign={"right"} alignItems="center">
                  <Button
                    testId="add-task"
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => setOpenCreateTask(true)}
                  >
                    <Add />
                    New Task
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Box>
          <Box pb={2}>
            <Paper className={classes.paper}>
              <SupportTasksToolbar />
            </Paper>
          </Box>
          <Box flex={1} display="flex">
            <Paper className={classes.paper} style={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <TaskListView
                overrideStores={{
                  tasksStore: supportTasksStore,
                  tasksGridStore: supportTasksGridStore,
                }}
              />
            </Paper>
          </Box>
        </Box>
        <EditSupportTaskDialog />
        <AddLoanTaskDialog
          open={openCreateTask}
          isSupportTask
          handleClose={handleCloseCreateTask}
          options={editTaskStore.loanTaskSectionNames.map(category => ({
            value: category.taskCategoryId,
            label: category.displayName,
          }))}
        />
      </Grid>
    </>
  );
});
